require('../../../styles/legacy_loader.scss');
require('../../../styles/main.css');
require('../../../styles/fonts.scss');
require('../../../styles/base.scss');

// App CSS
require('../../../styles/sbp.scss');
require('../../../styles/client-app/layout.scss');
